module.exports = __webpack_public_path__ + "static/media/pallete.04e2ea1d.svg";